import { render, staticRenderFns } from "./PasteFromClipboard.vue?vue&type=template&id=032fca42"
import script from "./PasteFromClipboard.vue?vue&type=script&lang=js"
export * from "./PasteFromClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports